import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import vco from "v-click-outside";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import store from "@/store";
import http from "@/http";
import * as tools from "@/tools";
import gmapsInit from "@/gmaps";
import DatePicker from "vue2-datepicker";
import VueTour from "vue-tour";
import money from "v-money";

import "vue2-datepicker/locale/pt-br";
import "../src/design/app.scss";

import App from "./App.vue";
import i18n from "./i18n";
import tinymce from "vue-tinymce-editor";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-tour/dist/vue-tour.css";
import VueLottie from "vue-lottie";

import DefaultLayout from "./pages/templates/DefaultLayout.vue";
import EmptyLayout from "./pages/templates/EmptyLayout.vue";

import trackerAssist from "@openreplay/tracker-assist";
import { tracker } from "@openreplay/tracker";

import { MonitorService } from "@/services/monitoramento/monitor/monitorService";

Vue.component("default-layout", DefaultLayout);
Vue.component("empty-layout", EmptyLayout);
Vue.component("vue-lottie", VueLottie);

Vue.component("tinymce", tinymce);
Vue.component("date-picker", DatePicker);
Vue.use(VueTour);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);
Vue.component("VueSlickCarousel", VueSlickCarousel);
Vue.use(money, { precision: 4 });

Vue.prototype.$gmaps = gmapsInit;
Vue.prototype.$http = http;
Vue.prototype.$tools = tools;

Vue.prototype.$caminhoFotoPerfil = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.$iconOcorrencia =
  "https://portal-api.unicampo.coop.br/markerGoogle/";

//"https://portal-api-dev.unicampo.coop.br/fotosUsuario/"
// Vue.prototype.$caminhoFotoPerfil = "https://portal-api-hmg.unicampo.coop.br/fotosUsuario/"
// Vue.prototype.$caminhoFotoPerfil = "https://portal-api.unicampo.coop.br/fotosUsuario/"

//Vue.prototype.$eventBus = new Vue();

const inicializarMonitor = async () => {
  try {
    const response = await MonitorService.buscaChavesMonitor();
    const valorChave = response.chave;

    if (valorChave) {
      tracker.configure({
        projectKey: valorChave,
        ingestPoint: "https://monitor.unicampo.coop.br/ingest",
        network: {
          capturePayload: true // Capture HTTP payload
        }
      });
      tracker.use(trackerAssist({}));
      tracker.start({
        userID: store.state.me?.nm_razao || "visitante"
      });
    }
  } catch (error) {
    console.warn("Não foi possível inicializar o monitor de sessão:", error);
  }
};

const init = async () => {
  await inicializarMonitor();

  const module = await import("./router");
  const router = await module.default;
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
};

init();
